import { render, staticRenderFns } from "./ClimateOnlineLabel.vue?vue&type=template&id=2db9e622"
import script from "./ClimateOnlineLabel.vue?vue&type=script&lang=js"
export * from "./ClimateOnlineLabel.vue?vue&type=script&lang=js"
import style0 from "./ClimateOnlineLabel.vue?vue&type=style&index=0&id=2db9e622&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports